export default __webpack_public_path__ + "static/media/coronavirus.97391e85.svg";